import { useState } from 'react';
import { Col, Dropdown, Input, Menu, Row } from 'antd';
import Colors from 'assets/Colors';
import HamburgerIcon from 'components/icons/HamburgerIcon';
import MoreOptionHorizontal from 'components/icons/MoreOptionHorizontal';

import Plus from 'components/icons/Plus';

import Union from 'components/icons/Union';
import { useTranslation } from 'react-i18next';
import Item from './Item';
import s from '../styles';

function List({
  variant,
  values,
  setFieldValue,
  indexVariants,
  deleteVariant,
  addItem,
  deleteItem,
  dragItem,
  dragOverItem,
  setisDraggig,
  setEditVariant,
  editVariant,
  variantBelongin,
  setvariantBelongin,
}) {
  const { t } = useTranslation();
  const [visibleAttributes, setvisibleAttributes] = useState(false);

  //
  //

  const [editItem, setEditItem] = useState([]);
  //

  function applyItemStyle(selected) {
    return {
      height: '45px',
      color: selected && Colors.text_on_secondary,
      marginBottom: '10px',
      borderRadius: '2px',
      hover: {
        backgroundColor: 'red',
        color: Colors.text_on_secondary,
      },
    };
  }

  const menu = (
    <Menu
      style={{
        overflow: 'auto',
        padding: '8px',
        paddingBottom: 0,
        minWidth: '147px',
        textAlign: 'center',
      }}
    >
      <Menu.Item
        // disabled={values.modifiers.length === 1}
        key="delete"
        onClick={() => {
          deleteVariant(indexVariants);
        }}
        style={{ ...applyItemStyle(), color: Colors.notification_failed }}
      >
        {t('actions.delete')}
      </Menu.Item>
    </Menu>
  );

  // const handle drag sorting
  const handleSort = () => {
    // duplicate items
    const _variants = [...values.variants];
    // remove and save the dragged item content
    const draggedItemContent = _variants.splice(dragItem.current, 1)[0];

    // switch the position
    _variants.splice(dragOverItem.current, 0, draggedItemContent);
    // reset the position ref
    dragItem.current = null;
    dragOverItem.current = null;

    // update the actual array
    setisDraggig(false);
    setFieldValue('variants', _variants);
  };

  return (
    <div
      draggable
      onDragStart={() => (
        (dragItem.current = indexVariants), setisDraggig(true)
      )}
      onDragEnter={() => (dragOverItem.current = indexVariants)}
      onDragEnd={handleSort}
      onDragOver={(e) => e.preventDefault()}
      style={{ minWidth: '720px' }}
    >
      <Row
        style={{
          height: '47px',
          display: 'flex',
          alignItems: 'center',
          backgroundColor:
            editVariant === indexVariants
              ? Colors.background_blurry
              : Colors.background_secondary,
        }}
      >
        <Col span={1} style={{ cursor: 'move' }}>
          <HamburgerIcon color="#959FAF" />
        </Col>
        <Col span={1} style={{ cursor: 'pointer' }}>
          <div onClick={() => setvisibleAttributes(!visibleAttributes)}>
            {visibleAttributes ? (
              <Union color="#959FAF" />
            ) : (
              <s.IconUnion>
                <Union color="#959FAF" />
              </s.IconUnion>
            )}
          </div>
        </Col>
        <Col span={10}>
          <Input
            onClick={() => [
              setvisibleAttributes(true),
              setEditVariant(indexVariants),
              setvariantBelongin([]),
            ]}
            style={{ borderColor: Colors.background_dividers, width: '216px' }}
            bordered={editVariant === indexVariants}
            value={values.variants[indexVariants].name}
            placeholder={t(
              'components.InventoryVariants.ListVariants.placeholderNameVariant'
            )}
            onChange={(e) =>
              setFieldValue(`variants[${indexVariants}].name`, e.target.value)
            }
          />
        </Col>
        <Col span={10}>
          <Input
            type="number"
            onClick={() => [
              setEditVariant(indexVariants),
              setvariantBelongin([]),
            ]}
            style={{ borderColor: Colors.background_dividers, width: '143px' }}
            bordered={editVariant === indexVariants}
            placeholder="2"
            value={values.variants[indexVariants].size}
            onChange={(e) =>
              setFieldValue(`variants[${indexVariants}].size`, e.target.value)
            }
          />
        </Col>
        <Col span={2}>
          {values.variants.length > 1 && (
            <s.TableCell>
              <Dropdown
                placement="bottomRight"
                overlay={menu}
                trigger={['click']}
                arrow
              >
                <div style={{ cursor: 'pointer', height: '15px' }}>
                  <MoreOptionHorizontal />
                </div>
              </Dropdown>
            </s.TableCell>
          )}
        </Col>
      </Row>
      {visibleAttributes && (
        <>
          <Row
            style={{
              background: Colors.GREY,
              height: '47px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Col span={1} style={{}} />
            <Col span={1} style={{}} />
            <Col span={10} style={{}}>
              <label style={{ fontWeight: '500' }}>
                {' '}
                {t('components.InventoryVariants.ListVariants.attributeName')}
              </label>
            </Col>
            <Col span={10} style={{}}>
              <label style={{ fontWeight: '500' }}>
                {' '}
                {t('components.InventoryVariants.ListVariants.referenceCode')}
              </label>
            </Col>
            <Col span={2} style={{}}>
              <div
                style={{ cursor: 'pointer' }}
                onClick={() => addItem(indexVariants)}
              >
                <Plus />
              </div>
            </Col>
          </Row>
          {variant.items.map((item, index) => (
            <Item
              key={index}
              index={index}
              values={values}
              indexVariants={indexVariants}
              setFieldValue={setFieldValue}
              deleteItem={deleteItem}
              setEditItem={setEditItem}
              editItem={editItem}
              setEditVariant={setEditVariant}
              setvariantBelongin={setvariantBelongin}
              variantBelongin={variantBelongin}
            />
          ))}
        </>
      )}
    </div>
  );
}

export default List;
